import React from 'react';
import { Link } from 'react-router-dom';
import { FiCheckCircle } from 'react-icons/fi';
import HomeCardsV2 from './HomeCardsV2';

const HomeHeroV2 = () => {
  return (
    <section className="home-hero-shell relative isolate min-h-[100svh] overflow-hidden bg-transparent pt-24 text-white">
      <div className="home-hero-streaks" aria-hidden="true">
        {Array.from({ length: 9 }, (_, index) => (
          <span key={index} className="home-hero-streak" />
        ))}
      </div>

      <div className="relative z-10 mx-auto flex min-h-[calc(100svh-6rem)] max-w-[1320px] flex-col items-center justify-center px-6 py-14 text-center md:px-10 md:py-16">
        <p className="mb-5 text-sm font-medium uppercase leading-tight tracking-[0.08em] text-white/55">
          Market Focused Data Analytics
        </p>

        <h1 className="home-hero-title max-w-[1260px] font-bold text-white">
          Build. <span className="home-hero-keyword">Validate. </span> Automate.{' '}
        </h1>

        <p className="mt-6 max-w-[940px] text-base font-thin leading-relaxed text-white/65 sm:text-lg md:text-xl md:leading-relaxed">
          We build research, automation, and analytics tools that help traders
          and investors backtest strategies and automate execution, for greater
          confidence and trading precision.
        </p>

        <div className="mt-8 flex w-full max-w-[460px] flex-col items-center justify-center gap-4 sm:flex-row">
          <Link
            to="/signup"
            className="inline-flex min-h-[50px] w-full items-center justify-center rounded-md bg-[#00df9a] px-8 text-base font-semibold text-[#1b1202] shadow-[0_0_34px_rgba(251,146,60,0.2)] transition duration-300 hover:bg-[#29B87F] hover:shadow-[0_0_42px_rgba(250,204,21,0.28)] focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:ring-offset-[#12181B] sm:w-[210px]"
          >
            Sign Up
          </Link>
          <Link
            to="/account"
            className="inline-flex min-h-[50px] w-full items-center justify-center rounded-md border-2 border-white/60 bg-transparent px-8 text-base font-medium text-white transition duration-300 hover:border-[#00df9a] hover:text-[#00df9a] focus:outline-none focus:ring-2 focus:ring-[#00df9a] focus:ring-offset-2 focus:ring-offset-[#12181B] sm:w-[210px]"
          >
            Start Free Trial
          </Link>
        </div>

        <div className="mb-24 mt-10 grid w-full max-w-[700px] gap-5 text-sm text-white/80 sm:grid-cols-3 md:text-base">
          <Link
            to="/backtesting"
            className="home-check-item flex items-center justify-center gap-2.5 rounded-md transition hover:text-white focus:outline-none focus:ring-2 focus:ring-[#ff4ca3] focus:ring-offset-2 focus:ring-offset-[#12181B]"
          >
            <FiCheckCircle className="home-check-icon h-5 w-5 shrink-0 text-[#ff4ca3]" />
            <span>Strategy Backtesting</span>
          </Link>
          <Link
            to="/automation"
            className="home-check-item flex items-center justify-center gap-2.5 rounded-md transition hover:text-white focus:outline-none focus:ring-2 focus:ring-[#f5b84b] focus:ring-offset-2 focus:ring-offset-[#12181B]"
          >
            <FiCheckCircle className="home-check-icon h-5 w-5 shrink-0 text-[#f5b84b]" />
            <span>Automated Execution</span>
          </Link>
          <Link
            to="/signals"
            className="home-check-item flex items-center justify-center gap-2.5 rounded-md transition hover:text-white focus:outline-none focus:ring-2 focus:ring-[#20c7ff] focus:ring-offset-2 focus:ring-offset-[#12181B]"
          >
            <FiCheckCircle className="home-check-icon h-5 w-5 shrink-0 text-[#20c7ff]" />
            <span>Realtime Trade Alerts</span>
          </Link>
        </div>

        <HomeCardsV2 />
      </div>
    </section>
  );
};

export default HomeHeroV2;
